import { render, staticRenderFns } from "./SankeyChart.vue?vue&type=template&id=011e0ad7&scoped=true"
import script from "./SankeyChart.vue?vue&type=script&lang=js"
export * from "./SankeyChart.vue?vue&type=script&lang=js"
import style0 from "./SankeyChart.vue?vue&type=style&index=0&id=011e0ad7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011e0ad7",
  null
  
)

export default component.exports